// src/components/Header.jsx
import React from 'react';
import { Wallet, ExternalLink } from 'lucide-react';

// OpenSea collection URL — update to your actual slug
const OPENSEA_URL = 'https://opensea.io/collection/dunk-poge';

export const Header = ({
  account,
  isConnected,
  isWrongNetwork,
  connectWallet,
  disconnect,
  stats
}) => {
  const isWalletAvailable = typeof window !== 'undefined' && !!window.ethereum;
  const isSoldOut = stats.remaining === 0;
  // Show address panel whenever an account is present, even on wrong network
  const hasAccount = !!account;

  const handleConnect = async () => {
    if (!isWalletAvailable) {
      alert('Please install MetaMask or another Web3 wallet!');
      return;
    }
    try {
      await connectWallet();
    } catch (error) {
      console.error('Error in connectWallet:', error);
    }
  };

  return (
    <header className="relative border-b-4 border-white bg-black p-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8 relative z-10 mt-6">

        {/* Logo */}
        <div className="relative">
          <h1
            className="text-3xl md:text-5xl lg:text-6xl font-black m-0 tracking-tight text-white font-mono"
            style={{ textShadow: '4px 4px 0 #FF0066' }}
          >
            DUNK POGE
          </h1>
          <div className="absolute -top-3 -right-6 bg-green-400 text-black px-3 py-1 font-black border-2 border-black -rotate-12 shadow-[2px_2px_0_0_#000] text-xs uppercase">
            ON-CHAIN
          </div>
        </div>

        {/* Wallet / action section */}
        <div className="flex flex-wrap items-center justify-end gap-4 w-full md:w-auto">
          {!hasAccount ? (
            // ── No wallet connected at all ──────────────────────────────────
            !isWalletAvailable ? (
              <a
                href="https://metamask.io/download/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-400 text-black font-black px-6 py-3 border-4 border-white flex items-center gap-2 text-sm uppercase font-mono shadow-[6px_6px_0_0_#00ff00] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[8px_8px_0_0_#00ff00] transition-all duration-200 ml-auto"
              >
                <Wallet size={20} />
                <span className="hidden sm:inline">INSTALL METAMASK</span>
              </a>
            ) : (
              <button
                onClick={handleConnect}
                className="bg-white text-black font-black px-6 py-3 border-4 border-white flex items-center gap-2 text-sm uppercase font-mono shadow-[6px_6px_0_0_#00ff00] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[8px_8px_0_0_#00ff00] transition-all duration-200 ml-auto active:scale-95"
              >
                <Wallet size={20} />
                <span className="hidden sm:inline">CONNECT WALLET</span>
              </button>
            )
          ) : (
            // ── Wallet connected (correct or wrong network) ─────────────────
            <div className="flex flex-wrap items-center gap-4 ml-auto">
              {/* Address badge — orange on wrong network, blue on mainnet */}
              <div className={`text-white px-5 py-3 border-4 border-white font-black text-sm font-mono min-w-[120px] text-center shadow-[4px_4px_0_0_rgba(255,255,255,0.8)] ${isWrongNetwork ? 'bg-orange-500' : 'bg-blue-500'}`}>
                {isWrongNetwork && (
                  <div className="text-[10px] uppercase mb-1 opacity-90">Wrong Network</div>
                )}
                <div className="truncate max-w-[120px] text-xs">
                  {account}
                </div>
              </div>
              <button
                onClick={disconnect}
                className="bg-red-500 text-white font-black px-6 py-3 border-4 border-white text-sm uppercase font-mono tracking-wider whitespace-nowrap shadow-[4px_4px_0_0_rgba(255,255,255,0.8)] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_0_rgba(255,255,255,0.8)] transition-all duration-200 active:scale-95"
              >
                DISCONNECT
              </button>
            </div>
          )}
        </div>

        {/* Stats bar — swaps to OpenSea CTA once sold out */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 -rotate-2 bg-green-400 text-black px-8 py-2 border-4 border-black flex gap-6 font-black text-sm uppercase z-20 whitespace-nowrap shadow-[4px_4px_0_0_#000]">
          {isSoldOut ? (
            <>
              <span>10,000 / 10,000 MINTED</span>
              <span className="border-l-2 border-black pl-6">SOLD OUT</span>
              <a
                href={OPENSEA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="border-l-2 border-black pl-6 flex items-center gap-1 hover:underline"
              >
                BUY ON OPENSEA <ExternalLink size={14} />
              </a>
            </>
          ) : (
            <>
              <span>{stats.totalSupply} / 10,000 MINTED</span>
              <span className="border-l-2 border-black pl-6">{stats.remaining} LEFT</span>
              <span className="border-l-2 border-black pl-6">{stats.price} ETH</span>
            </>
          )}
        </div>

      </div>
    </header>
  );
};